import React from 'react';
import UserCardItem from './UserCardItem';

const UserCardItems = ({
  allowUserLink,
  allowRoleLink,
  allowApprovedStatus,
  allowTools,
  category,
  items,
  onCheckBoxClick,
  single,
}) => (
  items.map((item, index) => (
    <UserCardItem
      key={`users_list_item_${item.code}`}
      category={category}
      user={item}
      upward={index > 4}
      allowUserLink={allowUserLink}
      allowRoleLink={allowRoleLink}
      allowApprovedStatus={allowApprovedStatus}
      allowTools={allowTools}
      onCheckBoxClick={onCheckBoxClick}
      single={single}
    />
  ))
);

export default UserCardItems;
